// The general conditions printed on every quotation. They are always included; the form only lets you ADD to them.
// SAMPLE WORDING: replace these lines with the exact text from the SERB Word template (one string per condition).
export const STANDARD_CONDITIONS: string[] = [
  'Rates are valid until the date shown under Quote Validity.',
  'All rates are subject to space and equipment availability at the time of booking.',
  'Customs duties, taxes, storage and demurrage are not included unless stated in the charges above.',
  'Transit times are estimates and are not guaranteed.',
];
